<eds-panel
  class="tax-list-info-filters"
  theme="dark"
  [edsSpacing]="(isHandheld$ | async) ? 'lg' : 'md'"
>
  <div edsGrid edsPadding edsPaddingBottom="sm">
    <div
      class="container container--wide"
      edsPadding
      [edsPaddingTop]="(isHandheld$ | async) ? 'md' : 'xs'"
    >
      <!-- Title, record details, reset and product type filter -->
      <div edsRow>
        <div edsCol [columnNumbers]="{ s: '4', m: '3', l: '7' }">
          <div
            edsFlexbox
            [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
            [alignItems]="(isHandheld$ | async) ? 'flex-start' : 'center'"
            edsPadding
            edsPaddingTop="sm"
          >
            <!-- Title -->
            <eds-title
              size="h2"
              [level]="1"
              [isLight]="true"
              edsSpacing="none"
              edsPadding
              edsPaddingRight="sm"
              >{{ taxYear + " "
              }}{{ "products.us-tax-info-page-heading" | translate }}
            </eds-title>
            <div
              edsFlexbox
              alignItems="center"
              [edsSpacing]="(isHandheld$ | async) ? 'sm' : 'none'"
              class="tax-list-info-filters__total-records-row"
            >
              <!-- Record details - showing X of Y -->
              <p
                edsSpacing="none"
                edsPadding
                edsPaddingRight="sm"
                *ngIf="totalRecords"
              >
                {{ "products.ppss-listing-shows" | translate }}
                <b>{{ filteredRecords }}</b>
                {{ "products.ppss-listing-of" | translate }}
                <b>{{ totalRecords }}</b>
                {{ "products.ppss-listing-items" | translate }}
              </p>
              <!-- Download All Button with flyout menu-->
              <eds-icon type="xls" size="normal"></eds-icon>
              <eds-flyout-menu
                edsPadding
                edsPaddingRight="sm"
                alignPosition="right"
                theme="dark"
                [title]="
                  'products.us-tax-info-excel-download-options' | translate
                "
                [items]="downloadTypes"
                ariaLabelledby="BasicMenuControl"
                [isNonLinkableClickAction]="true"
                (menuItemSelectedWithIndexOutput)="selectDownloadType($event)"
              ></eds-flyout-menu>

              <!-- Reset filter(s) -->
              <div
                *ngIf="
                  isAnyFilterPresent &&
                  (selectedFilters?.selectedDropdowns?.length ||
                    selectedFilters?.searchedText)
                "
                edsFlexbox
                alignItems="center"
              >
                <span edsPadding edsPaddingRight="sm">|</span>
                <eds-link-item
                  edsFlexbox
                  justifyContent="flex-end"
                  theme="dark"
                  [title]="'products.ppss-filter-reset' | translate"
                  [hasIcon]="true"
                  type="reset"
                  class="text-white"
                  (click)="onFilterReset($event)"
                ></eds-link-item>
              </div>
            </div>
          </div>
        </div>

        <!-- Product type filter -->
        <div
          edsCol
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          *ngIf="isAnyFilterPresent && productTypeFilter"
        >
          <eds-dropdown
            edsSpacing="none"
            [attr.aria-label]="
              'products.ppss-filter-' + productTypeFilter.filterLabel
                | translate
            "
            [dropdownId]="productTypeFilter.filterName"
            name="drop-down"
            [multi]="true"
            [items]="productTypeFilter.filterItems"
            [label]="
              'products.ppss-filter-' + productTypeFilter.filterLabel
                | translate
            "
            [titleText]="'products.ppss-filter-select' | translate"
            [selectedText]="'products.ppss-filter-selected' | translate"
            (dropdownChange)="
              onDropdownChange(productTypeFilter.filterName, $event)
            "
            edsPadding
            edsPaddingLeft="none"
            edsFlexItem
            flexGrow="1"
            justifyContent="flex-end"
            #filterDropdowns
          ></eds-dropdown>
        </div>
      </div>

      <!-- Other filter(s) and search by keyword -->
      <div edsRow edsPadding edsPaddingTop="md" *ngIf="isAnyFilterPresent">
        <!-- Other filter(s) -->
        <eds-dropdown
          *ngFor="let filterType of otherFilterTypes"
          edsCol
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          [isActiveMenuLeft]="(isHandheld$ | async) === false"
          edsSpacing="md"
          [style.whiteSpace]="'nowrap'"
          [attr.aria-label]="
            'products.ppss-filter-' + filterType.filterLabel | translate
          "
          [dropdownId]="filterType.filterName"
          name="drop-down"
          [multi]="true"
          [items]="filterType.filterItems"
          [label]="'products.ppss-filter-' + filterType.filterLabel | translate"
          [titleText]="'products.ppss-filter-select' | translate"
          [selectedText]="'products.ppss-filter-selected' | translate"
          (dropdownChange)="onDropdownChange(filterType.filterName, $event)"
          #filterDropdowns
        ></eds-dropdown>

        <!-- Search by keyword -->
        <eds-search
          *ngIf="isSearchByKeyword"
          edsCol
          fieldId="search__field"
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          edsSpacing="md"
          [placeholder]="'products.ppss-filter-search-placeholder' | translate"
          edsPadding
          edsPaddingLeft="none"
          flexGrow="1"
          edsPaddingBottom="md"
          (searchTerm)="onSearchInput($event)"
          #filterSearch
        ></eds-search>
      </div>
    </div>
  </div>
</eds-panel>
